import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LandingPage.scss";
import CommonButton from "../../components/CommonButton/CommonButton";
import CommonLoader from "../../components/CommonLoader/CommonLoader";
import apiClient from "../../api/apiClient";
import apiEndpoints from "../../api/apiEndpoints";
import Footer from "../Footer/Footer";
import ListingPage from "../ListingPage/ListingPage";

interface Country {
  id: number;
  countryName: string;
  countryCode: string;
}

interface ClientInfo {
  clientId: number | string;
  clientName: string;
  sessionId: number | string;
  sessionkey: string;
  logoURL: string | null;
  roboGifUrl: string | null;
  eevaGreetings: string;
  introLine1: string;
  introLine2: string;
  country: Country[];
  copyrightText: string;
}

const LandingPage: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [isDataFetching, setIsDataFetching] = useState(true);
  const [questionsPage, setQuestionsPage] = useState<boolean>(false);
  const [domain, setDomain] = useState<string>("");
  const [clientId, setClientId] = useState<string | number>("");
  const [welcomeData, setWelcomeData] = useState<ClientInfo>({
    clientId: "",
    clientName: "",
    sessionId: "",
    sessionkey: "",
    logoURL: "",
    roboGifUrl: "",
    eevaGreetings: "",
    introLine1: "",
    introLine2: "",
    country: [],
    copyrightText: "",
  });
  const navigate = useNavigate();

  const fetchClientId = async (domain: string) => {
    setLoading(true);
    try {
      const response = await apiClient.get<ClientInfo[]>(
        apiEndpoints.getClientInfoByDomain(),
        {
          params: { domain },
        }
      );
      if (response.data && response.data.length) {
        setWelcomeData(response.data[0]);
        setClientId(response.data[0].clientId);
      } else {
        console.error("Client ID not found for this domain.");
        setWelcomeData({
          clientId: "",
          clientName: "",
          sessionId: "",
          sessionkey: "",
          logoURL: "",
          roboGifUrl: "",
          eevaGreetings: "",
          introLine1: "",
          introLine2: "",
          country: [],
          copyrightText: "",
        });
      }
    } catch (error) {
      console.error("Error fetching clientId:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleGetQuestionsClick = () => {
    setLoading(true);

    setQuestionsPage(true);
  };

  useEffect(() => {
    const eevaDomain = window.location.hostname;
    let currentDomain = "";
    if (eevaDomain === "localhost") {
      currentDomain = "voidsolutions.in";
    } else {
      currentDomain = eevaDomain;
    }
    setDomain(currentDomain);
    fetchClientId(currentDomain);
  }, []);

  return (
    <>
      {loading && !questionsPage ? (
        <CommonLoader />
      ) : questionsPage ? (
        <>
          {isDataFetching && <CommonLoader />}
          <></>
          <ListingPage
            clientId={clientId}
            logoURL={welcomeData.logoURL}
            clientName={welcomeData.clientName}
            sessionId={welcomeData.sessionId}
            countries={welcomeData.country}
            onDataFetched={() => setIsDataFetching(false)}
          />
        </>
      ) : welcomeData.eevaGreetings !== "" ? (
        <div className="content-container">
          <div className="banner-container"></div>
          <div className="d-flex flex-column align-center-mobile margin-bottom-100">
            <img
              src={
                welcomeData.logoURL && welcomeData.logoURL !== "null"
                  ? welcomeData.logoURL
                  : "/assets/images/void_logo_white.png"
              }
              className="banner-void-logo"
              alt="eeva-logo"
            />
            <div className="questions-container h-100">
              <div className="form-page active-page">
                <span className="eeva-intro-msg fw-bold z-2">
                  {welcomeData.eevaGreetings}
                </span>
                <div className="eeva-container vertical-center">
                  <img
                    src={
                      welcomeData.roboGifUrl &&
                      welcomeData.roboGifUrl !== "null"
                        ? welcomeData.roboGifUrl
                        : "/assets/images/eeva/eeva_default.gif"
                    }
                    alt="EveA"
                  />
                </div>
                <p className="fw-bold">{welcomeData.introLine1}</p>
                <p>{welcomeData.introLine2}</p>
                <CommonButton
                  btnText="Start"
                  onClick={handleGetQuestionsClick}
                  className="fill-btn"
                  color="#FFF"
                  height="40px"
                  backgroundColor="none"
                  border="none"
                  borderRadius="24px"
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>No data found</>
      )}
      {clientId !== "" && (
        <Footer clientId={clientId} copyrightText={welcomeData.copyrightText} />
      )}
    </>
  );
};

export default LandingPage;
